/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ existing: NonNullable<unknown> }} Sanction_Downgrade_WarningInputs */



/**
* | output |
* | --- |
* | "Selected level is lower than existing {existing} sanction" |
*
* @param {Sanction_Downgrade_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_downgrade_warning = /** @type {((inputs: Sanction_Downgrade_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Downgrade_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le niveau sélectionné est inférieur à la sanction ${i?.existing} existante`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El nivel seleccionado es inferior a la sanción ${i?.existing} existente`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`O nível selecionado é inferior à sanção ${i?.existing} existente`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il livello selezionato è inferiore alla sanzione ${i?.existing} esistente`)
	return /** @type {LocalizedString} */ (`Selected level is lower than existing ${i?.existing} sanction`)
});